import { createSelector } from "reselect"
import { getByPath } from "../utils"
import { IRootStateType } from "../types"
import { useMemo } from "react"
import { useSelector } from "react-redux"
import { ThemeOptions, Theme } from "@mui/material"
import { RootState } from "../app/store"

const getThemeValueInfo = (
  path: string,
  themeOptions: ThemeOptions,
  themeObject: Theme
) => {
  const valFromSaved = getByPath(themeOptions, path)
  return {
    modifiedByUser: valFromSaved !== undefined,
    value: getByPath(themeObject, path),
  }
}

const makeThemeValueInfoSelector = () =>
  createSelector(
    (_: any, path: string) => path,
    (state: RootState) => state.theme.themeOptions,
    (state: RootState) => state.theme.themeObject,
    getThemeValueInfo
  )

export const useThemeValueInfo = (path: string) => {
  const selectThemeValue = useMemo(makeThemeValueInfoSelector, [])

  return useSelector((state: IRootStateType) => selectThemeValue(state, path))
}

export const useThemeValue = (path: string) => useThemeValueInfo(path).value

export const canSave = (state: any) =>
  state.editor.savedVersion !== state.editor.currentVersion

export const useCanSave = () =>
  useSelector((state: IRootStateType) => canSave(state))
